// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const MfaProviderSchema = z.enum(['EMAIL','SMS','OTP','WEBHOOK'] as const);

export type MfaProviderType = `${z.infer<typeof MfaProviderSchema>}`

export default MfaProviderSchema;
